import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import BlurModal from '../../../../../../src/components/common/blur-modal';
import Button from '../../../../../../src/components/common/button';

class AppIdlePopup extends PureComponent {

  resetTime = (e) => {
    this.props.resetTime(e)
    this.props.inactive.setPopupVisibility(false);  //WMCE-32351
   }
  
 logoutFunction= (e) => {
  this.props.logoutFunction(e)   
  }

  logoutAtZero = () => {
    this.props.logoutAtZero()
  }
 
  render() {
    const { inactive, i18n: { messages } } = this.props;
      //WMCE-17601: Remain logged in popup going to negative timer
        // Changing the ccondition to logout even when timer goes negative
        if(this.props.inactive.countdown <= 0)
        {
          //console.log("GOING TO LOGOUT : " + this.props.inactive.countdown) 
             this.logoutAtZero();
        }

        return (
        
          <BlurModal
            visible={true}
            size="large"
            doneVisible={false}
            title={"Deutsche Wealth Online"}
            disableOutsideClick={true}
            onDone={() => this.props.inactive.setPopupVisibility(false)}
          >
            

            <div className="timeout-modal">
              <div className="row">
                <div className="small-12 text-center">
                  <div className="callout">

                    <h2>{messages['app.common.appIdle.remailLogged']}</h2>
                    <div>{messages['app.common.appIdle.logoutMsg']} {inactive.countdown} {messages['app.common.appIdle.seconds']}</div>

                    <div className="row">
                      <div className="column small-push-3 small-6 pad-top-20">

                        <div className="row">
                          <div className="column small-6" style={{color: '#fff', lineHeight: 2 }} >
                            <Button  testID="yes_button_logout_popup" id="yes_button_logout_popup" title={"Yes"} size="normal" onClick={(e) =>this.resetTime(e)} />
                          </div>
                        
                          <div className="column small-6" name="inactiveno" style={{color: '#fff', lineHeight: 2 }} >
                            <Button  testID="no_button_logout_popup" id="no_button_logout_popup" title={"No"} size="normal" onClick={(e) => this.logoutFunction(e)} />
                          </div>

                        </div>

                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </BlurModal>

        )
    }
  }

export default createContainer({
  $queries: {
    logout: { $call: 'auth.logout' },
    rmLogout: { $call : 'rmAccess.logout'},
    i18n: {
      messages: true,
    },
    inactive: {
      countdown: true,
      startCountdownTimer: { $call: 'startCountdownTimer' },
      stopCountdownTimer: { $call: 'stopCountdownTimer' },
      setPopupVisibility: { $call: 'setPopupVisibility'},  //WMCE-32351
      autoLogoutEvent: true,
    },
}})(AppIdlePopup);
